export default __webpack_public_path__ + "static/media/qatar_flag.bc86d39c.png";